import { Link } from "react-router-dom";
import { Icons } from "assets";
import styles from "./style.module.scss";
import classNames from "classnames";

interface CustomLinkHeaderProps {
  title: string;
  linkText?: string;
  linkHref?: string;
  linkState?: any;
}

const CustomLinkHeader = ({
  title,
  linkText,
  linkHref,
  linkState,
}: CustomLinkHeaderProps) => {
  return (
    <div className={classNames(styles.container, "flex justify-between")}>
      <h6>{title}</h6>
      {linkText && linkHref && (
        <Link
          to={linkHref}
          state={linkState}
          className={classNames("flex items-center gap-2", styles.link)}
        >
          <Icons.ArrowRightCircle />
          {linkText}
        </Link>
      )}
    </div>
  );
};

export default CustomLinkHeader;
